export default __webpack_public_path__ + "static/media/bod.0eddc9da.jpg";